export type LoginToastOptions = {
  showSuccessToast?: boolean;
};

export function shouldShowLoginSuccessToast(options?: LoginToastOptions) {
  return options?.showSuccessToast !== false;
}
